<template>
  <div class="w-100bf h-100bf" v-loading="loading"></div>
</template>

<script>
  export default {
    data() {
      return {
        loading: true,
        time: 0
      };
    },
    methods: {

    },
    created() {
      this.timeFn();
    },
    mounted() {
      
    },
    methods: {
      timeFn(){
        setTimeout(()=>{
          this.time = this.time + 1;
          if(this.time > 15 && !LocalStorage.getItem('obj')){
            this.$Msg.error('自动登录超时');
            console.log('定时中转页触发退出......');
            window.vm.$router.push("/");
          }else{
            this.timeFn();
          }
        }, 1000)
      }
    }
  };
</script>


// WEBPACK FOOTER //
// zzPage.vue?9283cdda